import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { call, put, takeLatest } from "redux-saga/effects";
import { getUserByToken, getAuthToken, getPersist } from "../../crud/auth.crud";
import * as routerHelpers from "../../router/RouterHelpers";
import axios from "axios";
const CancelToken = axios.CancelToken;
let cancel;

export const actionTypes = {
    Login: "[Login] Action",
    Logout: "[Logout] Action",
    Register: "[Register] Action",
    UserRequested: "[Request User] Action",
    UserLoaded: "[Load User] Auth API",
    fetchChartDetailRequest: "[fetchChartDetailRequest] Action",
    fetchChartDetailSuccess: "[fetchChartDetailSuccess] Action",
    fetchChartDetailFailure: "[fetchChartDetailFailure] Action",
    fetchDashboardDetailRequest: "[fetchDashboardDetailRequest] Action",
    fetchDashboardDetailSuccess: "[fetchDashboardDetailSuccess] Action",
    fetchDashboardDetailFailure: "[fetchDashboardDetailFailure] Action",
    fetchRoleListRequest: "[fetchRoleListRequest] Action",
    fetchRoleListSuccess: "[fetchRoleListSuccess] Action",
    fetchRoleListFailure: "[fetchRoleListFailure] Action",
    fetchRolePermissionListRequest: "[fetchRolePermissionListRequest] Action",
    fetchRolePermissionListSuccess: "[fetchRolePermissionListSuccess] Action",
    fetchRolePermissionListFailure: "[fetchRolePermissionListFailure] Action",
    fetchRoleDetailsRequest: "[fetchRoleDetailsRequest] Action",
    fetchRoleDetailsSuccess: "[fetchRoleDetailsSuccess] Action",
    fetchRoleDetailsFailure: "[fetchRoleDetailsFailure] Action",
    saveRoleDetailRequest: "[saveRoleDetailRequest] Action",
    saveRoleDetailSuccess: "[saveRoleDetailSuccess] Action",
    saveRoleDetailFailure: "[saveRoleDetailFailure] Action",
    deleteRoleDetailRequest: "[deleteRoleDetailRequest] Action",
    deleteRoleDetailSuccess: "[deleteRoleDetailSuccess] Action",
    deleteRoleDetailFailure: "[deleteRoleDetailFailure] Action",
    fetchTempRequest: "[fetchTempRequest] Action",
    resetPasswordRequest: "[resetPasswordRequest] Action",
    resetPasswordSuccess: "[resetPasswordSuccess] Action",
    resetPasswordFailure: "[resetPasswordFailure] Action",
    fetchProfileRequest: "[fetchProfileRequest] Action",
    fetchProfileSuccess: "[fetchProfileSuccess] Action",
    fetchProfileFailure: "[fetchProfileFailure] Action",
    saveProfile: "[saveProfile] Action",
    saveProfileSuccess: "[saveProfileSuccess] Action",
    saveProfileFailure: "[saveProfileFailure] Action",

    fetchSalesOrderFilterListRequest: "[fetchSalesOrderFilterListRequest] Action",
    fetchSalesOrderFilterListSuccess: "[fetchSalesOrderFilterListSuccess] Action",
    fetchSalesOrderFilterListFailure: "[fetchSalesOrderFilterListFailure] Action",
    fetchreferralNameRequest: "[fetchreferralNameRequest] Action",
    fetchreferralNameSuccess: "[fetchreferralNameSuccess] Action",
    fetchreferralNameFailure: "[fetchreferralNameFailure] Action",
    fetchSalesOrderFilterListAdherenceInfoRequest: "[fetchSalesOrderFilterListAdherenceInfoRequest] Action",
    fetchSalesOrderFilterListAdherenceInfoSuccess: "[fetchSalesOrderFilterListAdherenceInfoSuccess] Action",
    fetchSalesOrderFilterListAdherenceInfoFailure: "[fetchSalesOrderFilterListAdherenceInfoFailure] Action",
    saveSalesFilter: "[saveSalesFilter] Action",

    fetchFilterList: "fetchFilterList",
    storeNonPapPatientDataNull: "storeNonPapPatientDataNull",

    fetchLogosRequest: "[fetchLogosRequest] Action",
    fetchLogosSuccess: "[fetchLogosSuccess] Action",
    fetchLogosFailure: "[fetchLogosFailure] Action",
    fetchLogoDetailRequest: "[fetchLogoDetailRequest] Action",
    fetchLogoDetailSuccess: "[fetchLogoDetailSuccess] Action",
    fetchLogoDetailFailure: "[fetchLogoDetailFailure] Action",
    saveLogoDetailRequest: "[saveLogoDetailRequest] Action",
    saveLogoDetailSuccess: "[saveLogoDetailSuccess] Action",
    saveLogoDetailFailure: "[saveLogoDetailFailure] Action",
    fetchAdherenceBreakdownDetailRequest: "[fetchAdherenceBreakdownDetailRequest] Action",
    fetchAdherenceBreakdownDetailSuccess: "[fetchAdherenceBreakdownDetailSuccess] Action",
    fetchAdherenceBreakdownDetailFailure: "[fetchAdherenceBreakdownDetailFailure] Action",
    LoginAs: "[LoginAs] Action",
    clearFilter: "[clearFilter] Action",

    fetchResmedSummaryDocRequest: "[fetchResmedSummaryDocRequest] Action",
    fetchResmedSummaryDocSuccess: "[fetchResmedSummaryDocSuccess] Action",
    fetchResmedSummaryDocFailure: "[fetchResmedSummaryDocFailure] Action",

    fetchNonPAPDashboardDetailsRequest: "[fetchNonPAPDashboardDetailsRequest] Action",
    fetchNonPAPDashboardDetailsSuccess: "[fetchNonPAPDashboardDetailsSuccess] Action",
    fetchNonPAPDashboardDetailsFailure: "[fetchNonPAPDashboardDetailsFailure] Action",
    fetchNonPAPSalesOrderDetailsListByStatusRequest: "[fetchNonPAPSalesOrderDetailsListByStatusRequest] Action",
    fetchNonPAPSalesOrderDetailsListByStatusSuccess: "[fetchNonPAPSalesOrderDetailsListByStatusSuccess] Action",
    fetchNonPAPSalesOrderDetailsListByStatusFailure: "[fetchNonPAPSalesOrderDetailsListByStatusFailure] Action",
    fetchNonPAPChartDetailRequest: "[fetchNonPAPChartDetailRequest] Action",
    fetchNonPAPChartDetailSuccess: "[fetchNonPAPChartDetailSuccess] Action",
    fetchNonPAPChartDetailFailure: "[fetchNonPAPChartDetailFailure] Action",
    fetchNonPAPPatientDetailRequest: "[fetchNonPAPPatientDetailRequest] Action",
    fetchNonPAPPatientDetailSuccess: "[fetchNonPAPPatientDetailSuccess] Action",
    fetchNonPAPPatientDetailFailure: "[fetchNonPAPPatientDetailFailure] Action",
    fetchNonPAPSalesListByFilterRequest: "[fetchNonPAPSalesListByFilterRequest] Action",
    fetchScreenedPatientListSuccess: "[fetchScreenedPatientListSuccess] Action",
    fetchScreenedPatientListFailure: "[fetchScreenedPatientListFailure] Action",
    fetchScreenedPatientListRequest: "[fetchScreenedPatientListRequest] Action",
    checkForMenuItemAccessSuccess: "[checkForMenuItemAccessSuccess] Action",
    checkForMenuItemAccessFailure: "[checkForMenuItemAccessFailure] Action",
    checkForMenuItemAccessRequest: "[checkForMenuItemAccessRequest] Action",

    fetchSalesRepresentativesSuccess: "[fetchSalesRepresentativesSuccess] Action",
    fetchSalesRepresentativesFailure: "[fetchSalesRepresentativesFailure] Action",
    fetchSalesRepresentativesRequest: "[fetchSalesRepresentativesRequest] Action",
    
    fetchPatientNotesListSuccess: "[fetchPatientNotesListSuccess] Action",
    fetchPatientNotesListFailure: "[fetchPatientNotesListFailure] Action",
    fetchPatientNotesListRequest: "[fetchPatientNotesListRequest] Action",
    fetchScreenerDataListSuccess: "[fetchScreenerDataListSuccess] Action",
    fetchScreenerDataListFailure: "[fetchScreenerDataListFailure] Action",
    fetchScreenerDataListRequest: "[fetchScreenerDataListRequest] Action",
    setAddPatientNotesRequest: "[setAddPatientNotesRequest] Action",
    setAddPatientNotesSuccess: "[setAddPatientNotesSuccess] Action",
    setAddPatientNotesFailure: "[setAddPatientNotesFailure] Action",
    setPandingSleepStudyRequest: "[setPandingSleepStudyRequest] Action",
    setPandingSleepStudySuccess: "[setPandingSleepStudySuccess] Action",
    setPandingSleepStudyFailure: "[setPandingSleepStudyFailure] Action",
    fetchMaskTypeListRequest: "[fetchMaskTypeListRequest] Action",
    fetchMaskTypeListSuccess: "[fetchMaskTypeListSuccess] Action",
    fetchMaskTypeListFailure: "[fetchMaskTypeListFailure] Action",
    
    deletePatientNoteRequest: "[deletePatientNoteRequest] Action",
    deletePatientNoteSuccess: "[deletePatientNoteSuccess] Action",
    deletePatientNoteFailure: "[deletePatientNoteFailure] Action",
};

const initialAuthState = {
    user: undefined,
    authToken: undefined,
    TempData: '',
    deliveriesData: '',
    dashboardData: '',
    saleOderInfoData: '',
    locationsData: '',
    userData: null,
    loading: false,
    sloading: false,
    loadingDeliveries: false,
    loadingTemp: false,
    loadingLocations: false,
    count: 0,
    soId: 0,
    modulelist: [],
    filterRes: { id: 1, name: 'New' },
    prevLoggedInResp: [],
    isFilterClear: false,

};

export const reducer = persistReducer(
    { storage, key: "userData", whitelist: ["user", "authToken", "modulelist", "referralParam", "organizationParam"] },
    (state = initialAuthState, action) => {
        switch (action.type) {
            case actionTypes.Login: {
                var authToken = action.payload.userData.liUserResponse[0].accessToken;
                var user = action.payload.userData.liUserResponse[0];
                var modulelist = action.payload.userData.liModuleNameByRoleIdResponse;
                var referralParam = action.payload.userData.liUserReferralResponse ? action.payload.userData.liUserReferralResponse.map(function (d) { return d['referralKey']; }).join(',') : '';
                var organizationParam = action.payload.userData.liOrganizationResponse ? action.payload.userData.liOrganizationResponse.map(function (d) { return d['organization']; }).join(',') : '';

                let localStorageItems = {
                    'user': JSON.stringify(user),
                    'authToken': authToken,
                }
                localStorage.setItem("persist:userData", JSON.stringify(localStorageItems));
                //localStorage.setItem("IsMaintenanceMsgDisplayed", false);

                localStorage.setItem("previousUser", JSON.stringify(action.payload.userData));

                return { authToken, user, modulelist, referralParam, organizationParam };
            }

            case actionTypes.Register: {
                var authToken = action.payload.userData.AccessToken;
                var user = action.payload.userData.UserDetail;
                return { authToken, user };
            }

            // case actionTypes.Logout: {
            //     localStorage.setItem("prevLoggedInEmail", '');
            //     localStorage.setItem("dashboardMsg", '');
            //     localStorage.setItem("persist:userData", '');
            //     routerHelpers.forgotLastLocation();
            //     return initialAuthState;
            // localStorage.removeItem("demo2-lastLocation_expiresIn");
            // localStorage.removeItem("demo2-lastLocation");
            // localStorage.removeItem("persist:userData");
            // window.localStorage.removeItem("persist:userData");
            // }

            case actionTypes.Logout: {
                    
                routerHelpers.forgotLastLocation();
                //localStorage.clear();
                 return initialAuthState;
            }


            case actionTypes.fetchProfileRequest: {
                return { ...state, loading: true };
            }

            case actionTypes.fetchProfileSuccess: {

                let userDetails = action.payload.payload.liUserByIDResponse[0];
                
                return {
                    ...state,
                    name: action.payload.payload.liUserByIDResponse[0].name,
                    title: action.payload.payload.liUserByIDResponse[0].title,
                    role: action.payload.payload.liUserByIDResponse[0].roleName,
                    roleId: action.payload.payload.liUserByIDResponse[0].roleId,
                    email: action.payload.payload.liUserByIDResponse[0].email,
                    phone: action.payload.payload.liUserByIDResponse[0].phone,
                    extension: state.user.extension,
                    imagePath: action.payload.payload.imagePath,
                    isPapUser: action.payload.payload.liUserByIDResponse[0].isPAPUser,
                    papType: action.payload.payload.liUserByIDResponse[0].papType,
                    airviewName: action.payload.payload.liUserByIDResponse[0].airviewName,
                    airviewOrganizationName: action.payload.payload.liUserByIDResponse[0].airviewOrganizationName,
                    encoreName: action.payload.payload.liUserByIDResponse[0].encoreName,
                    encoreSleepLab: action.payload.payload.liUserByIDResponse[0].encoreSleepLab,
                    avatar: action.payload.payload.liUserByIDResponse[0].avatar,
                    npi: action.payload.payload.liUserByIDResponse[0].npi,
                    referralList: action.payload.payload.liReferralList,
                    screenerEmailFrequency: action.payload.payload.liUserByIDResponse[0].screenerEmailFrequency,
                    globalSummaryAccess: action.payload.payload.liUserByIDResponse[0].globalSummaryAccess,
                    sleepScreenerAccess: action.payload.payload.liUserByIDResponse[0].sleepScreenerAccess,
                    userDetails: userDetails,
                    loading: false
                };
            }
            case actionTypes.fetchProfileFailure: {
                return {
                    ...state,
                    name: '',// action.payload.payload.liUserByIDResponse[0].name,
                    title: '',//  action.payload.payload.liUserByIDResponse[0].title,
                    role: '',//  action.payload.payload.liUserByIDResponse[0].roleName,
                    roleId: '',
                    email: '',//  action.payload.payload.liUserByIDResponse[0].email,
                    isPapUser: '',
                    papType: '',
                    airviewName: '',
                    airviewOrganizationName: '',
                    encoreName: '',
                    encoreSleepLab: '',
                    loading: false,
                    avatar: '',
                    nPI: '',
                    screenerEmailFrequency: '',
                    globalSummaryAccess: '',
                    sleepScreenerAccess: '',
                };
            }

            case actionTypes.saveProfile: {
                return { ...state, authParams: action.payload.authParams };
            }
            case actionTypes.saveProfileSuccess: {
                return { ...state, saveProfileResponse: action.payload.response };
            }
            case actionTypes.saveProfileFailure: {
                return { ...state };
            }

            case actionTypes.UserLoaded: {
                var { user } = action.payload;

                return { ...state, user };
            }

            case actionTypes.resetPasswordRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.resetPasswordSuccess: {
                return { ...state, response: action.payload.payload, loading: false };
            }
            case actionTypes.resetPasswordFailure: {
                return { ...state, response: action.payload, loading: false };
            }

            case actionTypes.fetchDashboardDetailRequest: {
                return { ...state, params: action.payload.params, fetchDashboardDetailResponseLoading: true };
            }
            case actionTypes.fetchDashboardDetailSuccess: {
                return { ...state, fetchDashboardDetailresponse: action.payload.payload, fetchDashboardDetailResponseLoading: false };
            }
            case actionTypes.fetchDashboardDetailFailure: {
                return { ...state, fetchDashboardDetailresponse: action.payload, fetchDashboardDetailResponseLoading: false };
            }

            case actionTypes.fetchChartDetailRequest: {
                return { ...state, params: action.payload.params, fetchChartDetailResponseLoading: true };
            }
            case actionTypes.fetchChartDetailSuccess: {
                return { ...state, fetchChartDetailresponse: action.payload.payload, fetchChartDetailResponseLoading: false };
            }
            case actionTypes.fetchChartDetailFailure: {
                return { ...state, fetchChartDetailresponse: action.payload.payload, fetchChartDetailResponseLoading: false };
            }

            case actionTypes.fetchSalesOrderFilterListRequest: {
                return { ...state, params: action.payload.params, fetchSalesOrderFilterListResponseLoading: true };
            }
            case actionTypes.fetchSalesOrderFilterListSuccess: {
                return { ...state, fetchSalesOrderFilterListresponse: action.payload.payload, fetchSalesOrderFilterListResponseLoading: false };
            }
            case actionTypes.fetchSalesOrderFilterListFailure: {
                return { ...state, fetchSalesOrderFilterListresponse: action.payload, fetchSalesOrderFilterListResponseLoading: false };
            }

            case actionTypes.fetchSalesOrderFilterListAdherenceInfoRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchSalesOrderFilterListAdherenceInfoSuccess: {
                return { ...state, fetchSalesOrderFilterListAdherenceInforesponse: action.payload.payload, loading: false };
            }
            case actionTypes.fetchSalesOrderFilterListAdherenceInfoFailure: {
                return { ...state, fetchSalesOrderFilterListAdherenceInforesponse: action.payload, loading: false };
            }
            case actionTypes.fetchRoleListRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchRoleListSuccess: {
                return { ...state, roleListResponse: action.payload.payload, loading: false };
            }
            case actionTypes.fetchRoleListFailure: {
                return { ...state, roleListResponse: action.payload.payload, loading: false };
            }

            case actionTypes.fetchRolePermissionListRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchRolePermissionListSuccess: {
                return { ...state, rolePermissionListResponse: action.payload.payload, loading: false };
            }
            case actionTypes.fetchRolePermissionListFailure: {
                return { ...state, rolePermissionListResponse: action.payload.payload, loading: false };
            }

            case actionTypes.saveRoleDetailRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.saveRoleDetailSuccess: {
                return { ...state, saveRoleResponse: action.payload.saveRoleResponse, loading: false };
            }
            case actionTypes.saveRoleDetailFailure: {
                return { ...state, saveRoleResponse: action.payload.saveRoleResponse, loading: false };
            }

            case actionTypes.deleteRoleDetailRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.deleteRoleDetailSuccess: {
                return { ...state, deleteRoleResponse: action.payload.deleteRoleResponse, loading: false };
            }
            case actionTypes.saveRoleDetailFailure: {
                return { ...state, deleteRoleResponse: action.payload.deleteRoleResponse, loading: false };
            }

            case actionTypes.deletePatientNoteRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.deletePatientNoteSuccess: {
                return { ...state, deletePatientNoteResponse: action.payload.deletePatientNote, loading: false };
            }
            case actionTypes.deletePatientNoteFailure: {
                return { ...state, deletePatientNoteResponse: action.payload.deletePatientNote, loading: false };
            }

            case actionTypes.fetchRoleDetailsRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchRoleDetailsSuccess: {
                return { ...state, roleDetailsResponse: action.payload.payload, loading: false };
            }
            case actionTypes.fetchRoleDetailsFailure: {
                return { ...state, roleDetailsResponse: action.payload.payload, loading: false };
            }

            case actionTypes.fetchreferralNameRequest: {
                return { ...state, params: action.payload.params };
            }
            case actionTypes.fetchreferralNameSuccess: {
                return { ...state, referralNameResponse: action.payload.referralNameResponse, isLoadingReferral: false };
            }
            case actionTypes.fetchreferralNameFailure: {
                return { ...state, referralNameResponse: action.payload.referralNameResponse, isLoadingReferral: false };
            }

            case actionTypes.fetchFilterList: {
                let objD = { id: 1, name: 'Ha' }
                return { ...state, filterRes: objD, loading: false };
            }

            case actionTypes.storeNonPapPatientDataNull: {
                return {
                    ...state, nonPAPPatientDetail: undefined, loading: false, nonPAPPatientDetailNum: 1 + Math.random() * (100 - 1)
                };
            }

            case actionTypes.saveSalesFilter: {
                return { ...state, salesFilter: action.payload.payload, isScrollToList: action.payload.isScrollToList || false, loading: false };
            }

            case actionTypes.fetchTempRequest: {
                return {
                    ...state,
                    loadingTemp: true,
                    Rts: 0,
                };
            }

            case actionTypes.fetchLogosRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchLogosSuccess: {
                return { ...state, fetchLogosResponse: action.payload.payload, loading: false };
            }
            case actionTypes.fetchLogosFailure: {
                return { ...state, fetchLogosResponse: action.payload, loading: false };
            }

            case actionTypes.fetchLogoDetailRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchLogoDetailSuccess: {
                return { ...state, fetchLogoDetailSuccess: action.payload.payload, loading: false };
            }
            case actionTypes.fetchLogoDetailFailure: {
                return { ...state, fetchLogoDetailFailure: action.payload.payload, loading: false };
            }

            case actionTypes.saveLogoDetailRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.saveLogoDetailSuccess: {
                return { ...state, saveLogoDetailResponse: action.payload.payload, loading: false };
            }
            case actionTypes.saveLogoDetailFailure: {
                return { ...state, saveLogoDetailResponse: action.payload.payload, loading: false };
            }

            case actionTypes.setAddPatientNotesRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.setAddPatientNotesSuccess: {
                return { ...state, setAddPatientNotesResponse: action.payload.payload, loading: false };
            }
            case actionTypes.setAddPatientNotesFailure: {
                return { ...state, setAddPatientNotesResponse: action.payload.payload, loading: false };
            }

            case actionTypes.setPandingSleepStudyRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.setPandingSleepStudySuccess: {
                return { ...state, setPandingSleepStudyResponse: action.payload.payload, loading: false };
            }
            case actionTypes.setPandingSleepStudyFailure: {
                return { ...state, setPandingSleepStudyResponse: action.payload.payload, loading: false };
            }


            case actionTypes.fetchMaskTypeListRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchMaskTypeListSuccess: {
                return { ...state, fetchMaskTypeListResponse: action.payload.payload, loading: false };
            }
            case actionTypes.fetchMaskTypeListFailure: {
                return { ...state, fetchMaskTypeListResponse: action.payload.payload, loading: false };
            }

            case actionTypes.LoginAs: {
                if (!action.payload.userData.success) {
                    localStorage.setItem("prevLoggedInEmail", '');
                    localStorage.setItem("dashboardMsg", '');
                    return;
                }

                var authToken = action.payload.userData.liLoginAsUserResponse[0].accessToken;
                var user = action.payload.userData.liLoginAsUserResponse[0];
                var modulelist = action.payload.userData.liLoginAsModuleNameByRoleIdResponse;
                var referralParam = action.payload.userData.liLoginAsUserReferralResponse ? action.payload.userData.liLoginAsUserReferralResponse.map(function (d) { return d['referralKey']; }).join(',') : '';
                var organizationParam = action.payload.userData.liLoginAsOrganizationResponse ? action.payload.userData.liLoginAsOrganizationResponse.map(function (d) { return d['organization']; }).join(',') : '';

                let localStorageItems = {
                    'user': JSON.stringify(user),
                    'authToken': authToken,
                }
                localStorage.setItem("persist:userData", '');
                localStorage.setItem("persist:userData", JSON.stringify(localStorageItems));
                //localStorage.setItem("IsMaintenanceMsgDisplayed", false);

                return { authToken, user, modulelist, referralParam, organizationParam };
            }

            case actionTypes.fetchAdherenceBreakdownDetailRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchAdherenceBreakdownDetailSuccess: {
                return { ...state, adherenceBreakdownDetail: action.payload.payload, loading: false, AdherenceBreakdownDetailNum: 1 + Math.random() * (100 - 1) };
            }
            case actionTypes.fetchAdherenceBreakdownDetailFailure: {
                return { ...state, adherenceBreakdownDetail: action.payload.payload, loading: false, AdherenceBreakdownDetailNum: 1 + Math.random() * (100 - 1) };
            }

            case actionTypes.clearFilter: {
                return {
                    ...state,
                    isFilterClear: action.payload.data.isFilterClear,
                };
            }
            case actionTypes.fetchResmedSummaryDocRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchResmedSummaryDocSuccess: {
                return { ...state, resmedSummaryDocSuccess: action.payload.payload, loading: false };
            }
            case actionTypes.fetchResmedSummaryDocFailure: {
                return { ...state, resmedSummaryDocFailure: action.payload.payload, loading: false };
            }


            case actionTypes.fetchNonPAPDashboardDetailsRequest: {
                return { ...state, params: action.payload.params, nonPAPDashboardDetailsLoading: true };
            }
            case actionTypes.fetchNonPAPDashboardDetailsSuccess: {
                return { ...state, nonPAPDashboardDetails: action.payload.payload, nonPAPDashboardDetailsLoading: false, nonPAPDashboardDetailsNum: 1 + Math.random() * (100 - 1) };
            }
            case actionTypes.fetchNonPAPDashboardDetailsFailure: {
                return { ...state, nonPAPDashboardDetails: action.payload.payload, nonPAPDashboardDetailsLoading: false, nonPAPDashboardDetailsNum: 1 + Math.random() * (100 - 1) };
            }

            case actionTypes.fetchNonPAPSalesOrderDetailsListByStatusRequest: {
                return { ...state, params: action.payload.params, nonPAPSalesOrderDetailsListByStatusLoading: true };
            }
            case actionTypes.fetchNonPAPSalesOrderDetailsListByStatusSuccess: {
                return { ...state, nonPAPSalesOrderDetailsListByStatus: action.payload.payload, nonPAPSalesOrderDetailsListByStatusLoading: false, nonPAPSalesOrderDetailsListByStatusNum: 1 + Math.random() * (100 - 1) };
            }
            case actionTypes.fetchNonPAPSalesOrderDetailsListByStatusFailure: {
                return { ...state, nonPAPSalesOrderDetailsListByStatus: action.payload.payload, nonPAPSalesOrderDetailsListByStatusLoading: false, nonPAPSalesOrderDetailsListByStatusNum: 1 + Math.random() * (100 - 1) };
            }

            case actionTypes.fetchNonPAPChartDetailRequest: {
                return { ...state, params: action.payload.params, nonPAPChartDetailLoading: true };
            }
            case actionTypes.fetchNonPAPChartDetailSuccess: {
                return { ...state, nonPAPChartDetail: action.payload.payload, nonPAPChartDetailLoading: false, nonPAPChartDetailNum: 1 + Math.random() * (100 - 1) };
            }
            case actionTypes.fetchNonPAPChartDetailFailure: {
                return { ...state, nonPAPChartDetail: action.payload.payload, nonPAPChartDetailLoading: false, nonPAPChartDetailNum: 1 + Math.random() * (100 - 1) };
            }

            case actionTypes.fetchNonPAPPatientDetailRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchNonPAPPatientDetailSuccess: {
                return { ...state, nonPAPPatientDetail: action.payload.payload, loading: false, nonPAPPatientDetailNum: 1 + Math.random() * (100 - 1) };
            }
            case actionTypes.fetchNonPAPPatientDetailFailure: {
                return { ...state, nonPAPPatientDetail: action.payload.payload, loading: false, nonPAPPatientDetailNum: 1 + Math.random() * (100 - 1) };
            }

            case actionTypes.fetchNonPAPSalesListByFilterRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }

            case actionTypes.fetchScreenedPatientListRequest: {
                return { ...state, params: action.payload.params, loading: true , sloading: true };
            }
            case actionTypes.fetchScreenedPatientListSuccess: {
                return { ...state, fetchScreenedPatientListresponse: action.payload.payload, loading: false, sloading: false };
            }
            case actionTypes.fetchScreenedPatientListFailure: {
                return { ...state, fetchScreenedPatientListresponse: action.payload, loading: false, sloading:false };
            }

            case actionTypes.checkForMenuItemAccessRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.checkForMenuItemAccessSuccess: {
                return { ...state, checkForMenuItemAccessresponse: action.payload.payload, loading: false };
            }
            case actionTypes.checkForMenuItemAccessFailure: {
                return { ...state, checkForMenuItemAccessresponse: action.payload, loading: false };
            }

            case actionTypes.fetchSalesRepresentativesRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchSalesRepresentativesSuccess: {
                return { ...state, fetchSalesRepresentativesresponse: action.payload.payload, loading: false };
            }
            case actionTypes.fetchSalesRepresentativesFailure: {
                return { ...state, fetchSalesRepresentativesresponse: action.payload, loading: false };
            }

            case actionTypes.fetchPatientNotesListRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchPatientNotesListSuccess: {
                return { ...state, fetchPatientNotesListresponse: action.payload.payload, loading: false };
            }
            case actionTypes.fetchPatientNotesListFailure: {
                return { ...state, fetchPatientNotesListresponse: action.payload, loading: false };
            }
            case actionTypes.fetchScreenerDataListRequest: {
                return { ...state, params: action.payload.params, loading: true };
            }
            case actionTypes.fetchScreenerDataListSuccess: {
                return { ...state, fetchScreenerDataListresponse: action.payload.payload, loading: false };
            }
            case actionTypes.fetchScreenerDataListFailure: {
                return { ...state, fetchScreenerDataListresponse: action.payload, loading: false };
            }
            
            default:
                return state;
        }
    }
);

export const actions = {
    login: userData => ({ type: actionTypes.Login, payload: { userData } }),
    register: (userData) => ({
        type: actionTypes.Register,
        payload: { userData }
    }),
    // fetchFilterList: () => {}
    fetchFilterList: (payload) => ({
        type: actionTypes.fetchFilterList,
        payload: { payload }
    }),

    storeNonPapPatientDataNull: () => ({
        type: actionTypes.storeNonPapPatientDataNull,
        payload: []
    }),

    logout: () => ({ type: actionTypes.Logout }),
    fulfillUser: user => ({ type: actionTypes.UserLoaded, payload: { user } }),

    fetchDashboardDetailRequest: (data) => ({
        type: actionTypes.fetchDashboardDetailRequest,
        payload: { data }
    }),
    fetchDashboardDetailSuccess: (payload) => ({
        type: actionTypes.fetchDashboardDetailSuccess,
        payload: { payload }
    }),
    fetchDashboardDetailFailure: (payload) => ({
        type: actionTypes.fetchDashboardDetailFailure,
        payload: { payload }
    }),
    fetchChartDetailRequest: (data) => ({
        type: actionTypes.fetchChartDetailRequest,
        payload: { data }
    }),
    fetchChartDetailSuccess: (payload) => ({
        type: actionTypes.fetchChartDetailSuccess,
        payload: { payload }
    }),
    fetchChartDetailFailure: (payload) => ({
        type: actionTypes.fetchChartDetailFailure,
        payload: { payload }
    }),



    fetchRoleListRequest: (data) => ({
        type: actionTypes.fetchRoleListRequest,
        payload: { data }
    }),
    fetchRoleListSuccess: (payload) => ({
        type: actionTypes.fetchRoleListSuccess,
        payload: { payload }
    }),
    fetchRoleListFailure: (payload) => ({
        type: actionTypes.fetchRoleListFailure,
        payload: { payload }
    }),

    fetchRolePermissionListRequest: (data) => ({
        type: actionTypes.fetchRolePermissionListRequest,
        payload: { data }
    }),
    fetchRolePermissionListSuccess: (payload) => ({
        type: actionTypes.fetchRolePermissionListSuccess,
        payload: { payload }
    }),
    fetchRolePermissionListFailure: (payload) => ({
        type: actionTypes.fetchRolePermissionListFailure,
        payload: { payload }
    }),

    saveRoleDetailRequest: (data) => ({
        type: actionTypes.saveRoleDetailRequest,
        payload: { data }
    }),
    saveRoleDetailSuccess: (saveRoleResponse) => ({
        type: actionTypes.saveRoleDetailSuccess,
        payload: { saveRoleResponse }
    }),
    saveRoleDetailFailure: (saveRoleResponse) => ({
        type: actionTypes.saveRoleDetailFailure,
        payload: { saveRoleResponse }
    }),

    deleteRoleDetailRequest: (data) => ({
        type: actionTypes.deleteRoleDetailRequest,
        payload: { data }
    }),
    deleteRoleDetailSuccess: (deleteRoleResponse) => ({
        type: actionTypes.deleteRoleDetailSuccess,
        payload: { deleteRoleResponse }
    }),
    deleteRoleDetailFailure: (deleteRoleResponse) => ({
        type: actionTypes.deleteRoleDetailFailure,
        payload: { deleteRoleResponse }
    }),

    deletePatientNoteRequest: (data) => ({
        type: actionTypes.deletePatientNoteRequest,
        payload: { data }
    }),
    deletePatientNoteSuccess: (deletePatientNote) => ({
        type: actionTypes.deletePatientNoteSuccess,
        payload: { deletePatientNote }
    }),
    deletePatientNoteFailure: (deletePatientNote) => ({
        type: actionTypes.deletePatientNoteFailure,
        payload: { deletePatientNote }
    }),
    
    fetchRoleDetailsRequest: (data) => ({
        type: actionTypes.fetchRoleDetailsRequest,
        payload: { data }
    }),
    fetchProfileRequest: () => ({
        type: actionTypes.fetchProfileRequest,
    }),
    fetchProfileSuccess: (payload) => ({

        type: actionTypes.fetchProfileSuccess,
        payload: { payload }
    }),
    fetchProfileFailure: (payload) => ({
        type: actionTypes.fetchProfileSuccess,
        payload: { payload }
    }),

    saveProfile: (authParams) => ({
        type: actionTypes.saveProfile,
        payload: { authParams }
    }),
    saveProfileSuccess: (response) => ({
        type: actionTypes.saveProfileSuccess,
        payload: { response }
    }),
    resetPasswordRequest: (data) => ({
        type: actionTypes.resetPasswordRequest,
        payload: { data }
    }),
    resetPasswordSuccess: (payload) => ({
        type: actionTypes.resetPasswordSuccess,
        payload: { payload }
    }),
    resetPasswordFailure: (payload) => ({
        type: actionTypes.resetPasswordFailure,
        payload: { payload }
    }),



    fetchRoleDetailsSuccess: (payload) => ({
        type: actionTypes.fetchRoleDetailsSuccess,
        payload: { payload }
    }),
    fetchRoleDetailsFailure: (payload) => ({
        type: actionTypes.fetchRoleDetailsFailure,
        payload: { payload }
    }),

    fetchSalesOrderFilterListRequest: (payload) => ({
        type: actionTypes.fetchSalesOrderFilterListRequest,
        payload: { payload }
    }),

    fetchSalesOrderFilterListSuccess: (payload) => ({
        type: actionTypes.fetchSalesOrderFilterListSuccess,
        payload: { payload }
    }),
    fetchSalesOrderFilterListFailure: (payload) => ({
        type: actionTypes.fetchSalesOrderFilterListFailure,
        payload: { payload }
    }),

    fetchSalesOrderFilterListAdherenceInfoRequest: (payload) => ({
        type: actionTypes.fetchSalesOrderFilterListAdherenceInfoRequest,
        payload: { payload }
    }),

    fetchSalesOrderFilterListAdherenceInfoSuccess: (payload) => ({
        type: actionTypes.fetchSalesOrderFilterListAdherenceInfoSuccess,
        payload: { payload }
    }),
    fetchSalesOrderFilterListAdherenceInfoFailure: (payload) => ({
        type: actionTypes.fetchSalesOrderFilterListAdherenceInfoFailure,
        payload: { payload }
    }),
    saveSalesFilter: (payload, isScrollToList) => ({
        type: actionTypes.saveSalesFilter,
        payload: { payload, isScrollToList }
    }),
    fetchreferralNameRequest: (params) => ({
        type: actionTypes.fetchreferralNameRequest,
        payload: { params }
    }),
    fetchreferralNameSuccess: (referralNameResponse) => ({
        type: actionTypes.fetchreferralNameSuccess,
        payload: { referralNameResponse }
    }),
    fetchreferralNameFailure: (referralNameResponse) => ({
        type: actionTypes.fetchreferralNameFailure,
        payload: { referralNameResponse }
    }),

    fetchLogosRequest: (payload) => ({
        type: actionTypes.fetchLogosRequest,
        payload: { payload }
    }),

    fetchLogosSuccess: (payload) => ({
        type: actionTypes.fetchLogosSuccess,
        payload: { payload }
    }),
    fetchLogosFailure: (payload) => ({
        type: actionTypes.fetchLogosFailure,
        payload: { payload }
    }),
    fetchLogoDetailRequest: (payload) => ({
        type: actionTypes.fetchLogoDetailRequest,
        payload: { payload }
    }),

    fetchLogoDetailSuccess: (payload) => ({
        type: actionTypes.fetchLogoDetailSuccess,
        payload: { payload }
    }),
    fetchLogoDetailFailure: (payload) => ({
        type: actionTypes.fetchLogoDetailFailure,
        payload: { payload }
    }),

    saveLogoDetailRequest: (payload) => ({
        type: actionTypes.saveLogoDetailRequest,
        payload: { payload }
    }),

    setAddPatientNotesRequest: (payload) => ({
        type: actionTypes.setAddPatientNotesRequest,
        payload: { payload }
    }),
    
    saveLogoDetailSuccess: (payload) => ({
        type: actionTypes.saveLogoDetailSuccess,
        payload: { payload }
    }),
    saveLogoDetailFailure: (payload) => ({
        type: actionTypes.saveLogoDetailFailure,
        payload: { payload }
    }),
    loginAs: userData => ({ type: actionTypes.LoginAs, payload: { userData } }),

    fetchAdherenceBreakdownDetailRequest: (payload) => ({
        type: actionTypes.fetchAdherenceBreakdownDetailRequest,
        payload: { payload }
    }),

    fetchAdherenceBreakdownDetailSuccess: (payload) => ({
        type: actionTypes.fetchAdherenceBreakdownDetailSuccess,
        payload: { payload }
    }),
    fetchAdherenceBreakdownDetailFailure: (payload) => ({
        type: actionTypes.fetchAdherenceBreakdownDetailFailure,
        payload: { payload }
    }),
    clearFilter: (data) => ({
        type: actionTypes.clearFilter,
        payload: { data }
    }),

    fetchResmedSummaryDocRequest: (payload) => ({
        type: actionTypes.fetchResmedSummaryDocRequest,
        payload: { payload }
    }),

    fetchResmedSummaryDocSuccess: (payload) => ({
        type: actionTypes.fetchResmedSummaryDocSuccess,
        payload: { payload }
    }),
    fetchResmedSummaryDocFailure: (payload) => ({
        type: actionTypes.fetchResmedSummaryDocFailure,
        payload: { payload }
    }),

    fetchNonPAPDashboardDetailsRequest: (payload) => ({
        type: actionTypes.fetchNonPAPDashboardDetailsRequest,
        payload: { payload }
    }),

    fetchNonPAPDashboardDetailsSuccess: (payload) => ({
        type: actionTypes.fetchNonPAPDashboardDetailsSuccess,
        payload: { payload }
    }),
    fetchNonPAPDashboardDetailsFailure: (payload) => ({
        type: actionTypes.fetchNonPAPDashboardDetailsFailure,
        payload: { payload }
    }),

    fetchNonPAPSalesOrderDetailsListByStatusRequest: (payload) => ({
        type: actionTypes.fetchNonPAPSalesOrderDetailsListByStatusRequest,
        payload: { payload }
    }),

    fetchNonPAPSalesOrderDetailsListByStatusSuccess: (payload) => ({
        type: actionTypes.fetchNonPAPSalesOrderDetailsListByStatusSuccess,
        payload: { payload }
    }),
    fetchNonPAPSalesOrderDetailsListByStatusFailure: (payload) => ({
        type: actionTypes.fetchNonPAPSalesOrderDetailsListByStatusFailure,
        payload: { payload }
    }),

    fetchNonPAPChartDetailRequest: (payload) => ({
        type: actionTypes.fetchNonPAPChartDetailRequest,
        payload: { payload }
    }),

    fetchNonPAPChartDetailSuccess: (payload) => ({
        type: actionTypes.fetchNonPAPChartDetailSuccess,
        payload: { payload }
    }),
    fetchNonPAPChartDetailFailure: (payload) => ({
        type: actionTypes.fetchNonPAPChartDetailFailure,
        payload: { payload }
    }),

    fetchNonPAPPatientDetailRequest: (payload) => ({
        type: actionTypes.fetchNonPAPPatientDetailRequest,
        payload: { payload }
    }),

    fetchNonPAPPatientDetailSuccess: (payload) => ({
        type: actionTypes.fetchNonPAPPatientDetailSuccess,
        payload: { payload }
    }),
    fetchNonPAPPatientDetailFailure: (payload) => ({
        type: actionTypes.fetchNonPAPPatientDetailFailure,
        payload: { payload }
    }),
    fetchNonPAPSalesListByFilterRequest: (payload) => ({
        type: actionTypes.fetchNonPAPSalesListByFilterRequest,
        payload: { payload }
    }),
    fetchScreenedPatientListRequest: (payload) => ({
        type: actionTypes.fetchScreenedPatientListRequest,
        payload: { payload }
    }),
    fetchScreenedPatientListSuccess: (payload) => ({
        type: actionTypes.fetchScreenedPatientListSuccess,
        payload: { payload }
    }),
    fetchScreenedPatientListFailure: (payload) => ({
        type: actionTypes.fetchScreenedPatientListFailure,
        payload: { payload }
    }),

    checkForMenuItemAccessRequest: (payload) => ({
        type: actionTypes.checkForMenuItemAccessRequest,
        payload: { payload }
    }),
    checkForMenuItemAccessSuccess: (payload) => ({
        type: actionTypes.checkForMenuItemAccessSuccess,
        payload: { payload }
    }),
    checkForMenuItemAccessFailure: (payload) => ({
        type: actionTypes.checkForMenuItemAccessFailure,
        payload: { payload }
    }),
    
    fetchSalesRepresentativesRequest: (payload) => ({
        type: actionTypes.fetchSalesRepresentativesRequest,
        payload: { payload }
    }),
    fetchSalesRepresentativesSuccess: (payload) => ({
        type: actionTypes.fetchSalesRepresentativesSuccess,
        payload: { payload }
    }),
    fetchSalesRepresentativesFailure: (payload) => ({
        type: actionTypes.fetchSalesRepresentativesFailure,
        payload: { payload }
    }),
    
    fetchPatientNotesListRequest: (payload) => ({
        type: actionTypes.fetchPatientNotesListRequest,
        payload: { payload }
    }),
    fetchPatientNotesListSuccess: (payload) => ({
        type: actionTypes.fetchPatientNotesListSuccess,
        payload: { payload }
    }),
    fetchPatientNotesListFailure: (payload) => ({
        type: actionTypes.fetchPatientNotesListFailure,
        payload: { payload }
    }),
    fetchScreenerDataListRequest: (payload) => ({
        type: actionTypes.fetchScreenerDataListRequest,
        payload: { payload }
    }),
    fetchScreenerDataListSuccess: (payload) => ({
        type: actionTypes.fetchScreenerDataListSuccess,
        payload: { payload }
    }),
    fetchScreenerDataListFailure: (payload) => ({
        type: actionTypes.fetchScreenerDataListFailure,
        payload: { payload }
    }),
    setAddPatientNotesRequest: (payload) => ({
        type: actionTypes.setAddPatientNotesRequest,
        payload: { payload }
    }),

    setAddPatientNotesSuccess: (payload) => ({
        type: actionTypes.setAddPatientNotesSuccess,
        payload: { payload }
    }),
    setAddPatientNotesFailure: (payload) => ({
        type: actionTypes.setAddPatientNotesFailure,
        payload: { payload }
    }),

    setPandingSleepStudyRequest: (payload) => ({
        type: actionTypes.setPandingSleepStudyRequest,
        payload: { payload }
    }),

    setPandingSleepStudySuccess: (payload) => ({
        type: actionTypes.setPandingSleepStudySuccess,
        payload: { payload }
    }),
    setPandingSleepStudyFailure: (payload) => ({
        type: actionTypes.setPandingSleepStudyFailure,
        payload: { payload }
    }),
    
    fetchMaskTypeListRequest: (payload) => ({
        type: actionTypes.fetchMaskTypeListRequest,
        payload: { payload }
    }),

    fetchMaskTypeListSuccess: (payload) => ({
        type: actionTypes.fetchMaskTypeListSuccess,
        payload: { payload }
    }),
    fetchMaskTypeListFailure: (payload) => ({
        type: actionTypes.fetchMaskTypeListFailure,
        payload: { payload }
    }),
};


export function* saga() {
    yield takeLatest(actionTypes.Login, function* loginSaga() {
    });

    yield takeLatest(actionTypes.UserRequested, function* userRequested() {
        const { data: user } = yield getUserByToken();
        yield put(actions.fulfillUser(user));
    });
    yield takeLatest(actionTypes.fetchProfileRequest, fetchProfileRequestSaga);
    yield takeLatest(actionTypes.saveProfile, saveProfileSaga);
    yield takeLatest(actionTypes.resetPasswordRequest, resetPasswordRequestSaga);

    yield takeLatest(actionTypes.fetchDashboardDetailRequest, fetchDashboardDetailSaga);
    yield takeLatest(actionTypes.fetchChartDetailRequest, fetchChartDetailSaga);
    yield takeLatest(actionTypes.fetchRoleListRequest, fetchRoleListSaga);
    yield takeLatest(actionTypes.fetchRolePermissionListRequest, fetchRolePermissionListSaga);
    yield takeLatest(actionTypes.saveRoleDetailRequest, saveRoleDetailSaga);
    yield takeLatest(actionTypes.deleteRoleDetailRequest, deleteRoleDetailSaga);
    yield takeLatest(actionTypes.deletePatientNoteRequest, deletePatientNoteSaga);
    yield takeLatest(actionTypes.fetchRoleDetailsRequest, fetchRoleDetailsSaga);
    yield takeLatest(actionTypes.resetPasswordRequest, resetPasswordRequestSaga);
    yield takeLatest(actionTypes.fetchSalesOrderFilterListRequest, fetchSalesOrderFilterListSaga);
    yield takeLatest(actionTypes.fetchSalesOrderFilterListAdherenceInfoRequest, fetchSalesOrderFilterListAdherenceInfoSaga);
    yield takeLatest(actionTypes.fetchreferralNameRequest, fetchreferralNameSaga);
    yield takeLatest(actionTypes.fetchLogosRequest, fetchLogosSaga);
    yield takeLatest(actionTypes.fetchLogoDetailRequest, fetchLogoDetailSaga);
    yield takeLatest(actionTypes.saveLogoDetailRequest, saveLogoDetailSaga);
    yield takeLatest(actionTypes.LoginAs, function* loginAsSaga() {
    });
    yield takeLatest(actionTypes.fetchAdherenceBreakdownDetailRequest, fetchAdherenceBreakdownDetailSaga);

    yield takeLatest(actionTypes.fetchResmedSummaryDocRequest, fetchResmedSummaryDocSaga);
    yield takeLatest(actionTypes.fetchNonPAPDashboardDetailsRequest, fetchNonPAPDashboardDetailsSaga);
    yield takeLatest(actionTypes.fetchNonPAPSalesOrderDetailsListByStatusRequest, fetchNonPAPSalesOrderDetailsListByStatusSaga);
    yield takeLatest(actionTypes.fetchNonPAPChartDetailRequest, fetchNonPAPChartDetailSaga);
    yield takeLatest(actionTypes.fetchNonPAPPatientDetailRequest, fetchNonPAPPatientDetailSaga);
    yield takeLatest(actionTypes.fetchNonPAPSalesListByFilterRequest, fetchNonPAPSalesListByFilterSaga);
    yield takeLatest(actionTypes.fetchScreenedPatientListRequest, fetchScreenedPatientListSaga);
    yield takeLatest(actionTypes.checkForMenuItemAccessRequest, checkForMenuItemAccessSaga);
    yield takeLatest(actionTypes.fetchSalesRepresentativesRequest, fetchSalesRepresentativesSaga);
    yield takeLatest(actionTypes.fetchPatientNotesListRequest, fetchPatientNotesListSaga);
    yield takeLatest(actionTypes.fetchScreenerDataListRequest, fetchScreenerDataListSaga);
    yield takeLatest(actionTypes.setAddPatientNotesRequest, setAddPatientNotesSaga);
    yield takeLatest(actionTypes.setPandingSleepStudyRequest, setPandingSleepStudySaga);
    yield takeLatest(actionTypes.fetchMaskTypeListRequest, fetchMaskTypeListSaga);

}


function* fetchDashboardDetailSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();

    const response = yield call(fetchDashboardDetailApi, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchDashboardDetailSuccess(response.data))
    }
    else {
        yield put(actions.fetchDashboardDetailFailure(response.data))
    }
};

const fetchDashboardDetailApi = async (authToken, userByToken, data) => {
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getdashboarddetail?RoleId=${data.data.RoleId}&OrganizationParam=${data.data.OrganizationParam}&ReferralParam=${data.data.ReferralParam}&Type=by_status`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${data.data.UserId}` }
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* fetchChartDetailSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchChartDetailApi, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchChartDetailSuccess(response.data))
    }
    else {
        yield put(actions.fetchChartDetailFailure(response.data))
    }
};

const fetchChartDetailApi = async (authToken, userByToken, data) => {
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/GetDeliveredAndComplaintChartDetail?Organization=${data.data.OrganizationParam}&ReferralKey=${data.data.ReferralParam}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${data.data.UserId}` }
    };
    const respo = instance.get(URL, options);
    return respo;
};


function* fetchRoleListSaga(payload) {
    const authToken = yield getAuthToken();
    const User = yield getUserByToken();
    const response = yield call(fetchRoleListApi, authToken, User, payload.payload.data);
    if (response.data.success) {
        yield put(actions.fetchRoleListSuccess(response.data))
    }
    else {
        yield put(actions.fetchRoleListFailure(response.data))
    }
};
const fetchRoleListApi = async (authToken, User, payload) => {
    let RtsCount = (payload.PageNo > 0) ? (payload.PageNo * payload.PageSize) : 0;
    var user = JSON.parse(User);
    var isSuperAdmin = user.roleName == "super-admin" ? 1 : 0;
    const URL = `${process.env.REACT_APP_API_URL}api/role/getrolelist?Search=${payload.Search}&OrderByFieldParam=${payload.OrderByFieldParam}&SortOrderParam=${payload.SortOrderParam}&PageSize=${payload.PageSize}&RowsToSkip=${RtsCount}`;
    const options = {
        headers: { 'Content-Type': "multipart/form-data", 'AccessToken': `${authToken.replace(/"/g,'')} `, 'UserId': `${user.userId}` }
    };
    let respo = axios.get(URL, options);
    return respo;
};

function* fetchRolePermissionListSaga(payload) {
    const authToken = yield getAuthToken();
    const User = yield getUserByToken();
    const response = yield call(fetchRolePermissionListApi, authToken, User, payload.payload.data);
    if (response.data.success) {
        yield put(actions.fetchRolePermissionListSuccess(response.data))
    }
    else {
        yield put(actions.fetchRolePermissionListFailure(response.data))
    }
};
const fetchRolePermissionListApi = async (authToken, User, payload) => {
    var user = JSON.parse(User);
    const URL = `${process.env.REACT_APP_API_URL}api/role/GetModuleForRole?roleid=${user.roleId}`;

    const options = {
        headers: { 'Content-Type': "multipart/form-data", 'AccessToken': `${authToken.replace(/"/g,'')} `, 'UserId': `${user.userId}` }
    };
    let respo = axios.get(URL, options);
    return respo;
};


function* saveRoleDetailSaga(payload) {
    const authToken = yield getAuthToken();
    const User = yield getUserByToken();
    const response = yield call(saveRoleApi, authToken, User, payload.payload.data);
    if (response.data.success) {
        yield put(actions.saveRoleDetailSuccess(response.data))
    }
    else {
        yield put(actions.saveRoleDetailFailure(response.data))
    }
};
const saveRoleApi = async (authToken, User, data) => {
    var user = JSON.parse(User);
    const request = {
        "StatementType": data.StatementType,
        "Id": data.Id,
        "name": data.name,
        "display_name": data.display_name,
        "isBaa": data.isBaa,
        "description": data.description,
        "Permission": data.Permission,
        "isInternalRole": data.isInternalRole
    }
    const URL = `${process.env.REACT_APP_API_URL}api/role/addandupdaterole`;
    const options = {
        headers: { 'Content-Type': 'application/json', 'AccessToken': `${authToken.replace(/"/g,'')} `, 'UserId': `${user.userId}` }
    };
    let respo = axios.post(URL, request, options);
    return respo;
};

// reset password
function* resetPasswordRequestSaga(payload) {
    const response = yield call(resetPasswordApi, payload.payload.data);
    if (response.data.success) {
        yield put(actions.resetPasswordSuccess(response.data))
    }
    else {
        yield put(actions.resetPasswordFailure(response.data))
    }
};

const resetPasswordApi = async (payload) => {
    const URL = `${process.env.REACT_APP_API_URL}api/user/resetpassword?Email=${payload.email}&Token=${payload.token}`;
    const formData = {
        "Password": payload.newPassword
    };
    const options = {
        headers: {
            'content-type': 'application/json',
        }
    };
    const response = axios.post(URL, formData, options);
    return response;
};

function* fetchreferralNameSaga(payload) {
   const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    let NickName = JSON.parse(localStorage.getItem("persist:userData")).organizationParam.replace(/"([^"]+(?="))"/g, '$1');
    let Id = '';
    
    let UserIdForReferralSearch = '';
    //if (localStorage.getItem('prevLoggedInEmail') || JSON.parse(localStorage.getItem("previousUser")).liUserResponse[0].roleId != 1) {
    if (JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).roleName != "super-admin" && JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).roleName != "mpcs-referral-admin") {
        const parsedJsonData = JSON.parse(userByToken);
        UserIdForReferralSearch = parsedJsonData.userId;
    }
    
    if (userByToken) {
        const parsedJsonData = JSON.parse(userByToken);
        Id = parsedJsonData.userId;
    }
    const response = yield call(referralNameApi, authToken, payload, NickName, Id,UserIdForReferralSearch);
    if (response.data.success == true) {
        yield put(actions.fetchreferralNameSuccess(response.data));
    }
    else{
        yield put(actions.fetchreferralNameFailure(response.data));
    }
};
const referralNameApi = async (authToken, data, NickName, Id,UserIdForReferralSearch) => {
    if (cancel !== undefined) {
        cancel();
    }
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getreferralsearchlist?OrganizationParam=${NickName}&FacilityAddress=&FacilityCity=&FacilityState=&FacilityZip=&FacilityPhone=&FacilityFax=&LimitParam=10&OffsetParam=0&OrderByFieldParam=&SortOrderParam=&SearchParam=${data.payload.params}&Id=&UserIdForReferralSearch=${UserIdForReferralSearch}`;
    const options = {
        headers: { 'Content-Type': "multipart/form-data", 'AccessToken': `${authToken.replace(/"/g, '')}`, "UserId": `${Id}` },
        cancelToken: new CancelToken(function executor(c) {
            cancel = c;
        })
    };
    const response = await axios.get(URL, options);
    return response;
}

// sales order
function* deleteRoleDetailSaga(payload) {
    const authToken = yield getAuthToken();
    const User = yield getUserByToken();
    const response = yield call(deleteRoleApi, authToken, User, payload.payload.data);
    if (response.data.success) {
        yield put(actions.deleteRoleDetailSuccess(response.data))
    }
    else {
        yield put(actions.deleteRoleDetailFailure(response.data))
    }
};
const deleteRoleApi = async (authToken, User, data) => {
    var user = JSON.parse(User);
    const request = {
        "ModuleName": data.moduleName,
        "Search": data.id
    }
    const URL = `${process.env.REACT_APP_API_URL}api/user/commondeleterequest`;
    const options = {
        headers: { 'Content-Type': 'application/json', 'AccessToken': `${authToken.replace(/"/g,'')} `, 'UserId': `${user.userId}` }
    };
    let respo = axios.post(URL, request, options);
    return respo;
};

function* deletePatientNoteSaga(payload) {
    const authToken = yield getAuthToken();
    const User = yield getUserByToken();
    const response = yield call(deletePatientNoteApi, authToken, User, payload.payload.data);
    if (response.data.success) {
        yield put(actions.deletePatientNoteSuccess(response.data))
    }
    else {
        yield put(actions.deletePatientNoteFailure(response.data))
    }
};
const deletePatientNoteApi = async (authToken, User, data) => {
    var user = JSON.parse(User);
    const request = data;
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/deletepatientnote`;
    const options = {
        headers: { 'Content-Type': 'application/json', 'AccessToken': `${authToken.replace(/"/g,'')} `, 'UserId': `${user.userId}` }
    };
    let respo = axios.post(URL, request, options);
    return respo;
};

function* fetchRoleDetailsSaga(payload) {
    const authToken = yield getAuthToken();
    const User = yield getUserByToken();
    const response = yield call(fetchRoleDetailsApi, authToken, User, payload.payload.data);
    if (response.data.success) {
        yield put(actions.fetchRoleDetailsSuccess(response.data))
    }
    else {
        yield put(actions.fetchRoleDetailsFailure(response.data))
    }
};
const fetchRoleDetailsApi = async (authToken, User, payload) => {
    var user = JSON.parse(User);
    const URL = `${process.env.REACT_APP_API_URL}api/role/GetRoleAndPermissionsByID`;
    const options = {
        headers: { 'Content-Type': "multipart/form-data", 'AccessToken': `${authToken.replace(/"/g,'')} `, 'UserId': `${user.userId}` },
        params: {
            RoleId: payload.id
        }
    };
    let respo = axios.get(URL, options);
    return respo;
};


function* fetchProfileRequestSaga(api, action) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    let Id = '';

    if (userByToken) {
        const parsedJsonData = JSON.parse(userByToken);
        Id = parsedJsonData.userId;
    }
    const response = yield call(fetchProfileApi, authToken, Id);
    if (response.data.success == true) {
        yield put(actions.fetchProfileSuccess(response.data));

        // var authToken = response.data.liUserByIDResponse[0].accessToken;
        let localStorageItems = localStorage.getItem("persist:userData");
        localStorageItems = JSON.parse(localStorageItems)
        let userData = JSON.parse(localStorageItems.user)
        if (userData.userId === response.data.liUserByIDResponse[0].userId) {
            userData.name = response.data.liUserByIDResponse[0].name;
            userData.title = response.data.liUserByIDResponse[0].title;
            userData.phone = response.data.liUserByIDResponse[0].phone;
            userData.extension = response.data.liUserByIDResponse[0].extension;
            userData.password = response.data.liUserByIDResponse[0].password;
            userData.ImageData = response.data.liUserByIDResponse[0].ImageData;
            userData.isPapUser = response.data.liUserByIDResponse[0].isPAPUser;
            userData.PapType = response.data.liUserByIDResponse[0].PapType;
            userData.CurrentImageName = response.data.liUserByIDResponse[0].CurrentImageName;
            userData.avatar = response.data.liUserByIDResponse[0].avatar;
            userData.avatarWithFullPath = response.data.imagePath
            localStorageItems.user = JSON.stringify(userData)
            localStorage.setItem("persist:userData", JSON.stringify(localStorageItems));
        }



    }
    else {
        yield put(actions.fetchProfileFailure(response.data));
    }
};

const fetchProfileApi = async (authToken, Id) => {
    const URL = `${process.env.REACT_APP_API_URL}api/user/getuserbyid?id=${Id}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${Id}` }
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* saveProfileSaga(payload) {
    const authToken = yield getAuthToken();
    const persistData = yield getPersist();
    const userByToken = yield getUserByToken();
    let parsedJsonData = '';
    let Id = '';
    if (userByToken) {
        parsedJsonData = JSON.parse(userByToken);
        Id = parsedJsonData.userId;
    }
    const response = yield call(saveProfileApi, authToken, payload, Id, parsedJsonData);
    yield put(actions.saveProfileSuccess(response.data));

};

const saveProfileApi = async (authToken, data, Id, parsedJsonData) => {
    const authParams = data.payload.authParams;
    var data = JSON.stringify({

        "statementType": data.payload.authParams.statementType,
        "name": data.payload.authParams.name,
        "title": data.payload.authParams.title,
        "phone": data.payload.authParams.phone,
        "extension": data.payload.authParams.extension,
        "password": data.payload.authParams.password,
        // "ImageData": data.payload.authParams.ImageData,
        // "CurrentImageName": data.payload.authParams.CurrentImageName == "" ? "" : Id + '.' + data.payload.authParams.CurrentImageName,
        // "IsDeleteImage": data.payload.authParams.IsDeleteImage,
        "NPI": data.payload.authParams.NPI,
        "isPapUser": data.payload.authParams.isPapUser,
        "PapType": data.payload.authParams.papType == 'n/a' ? '' : data.payload.authParams.papType,
        "airviewName": data.payload.authParams.airviewName,
        "AirviewOrganizationName": data.payload.authParams.airviewOrganizationName,
        "EncoreName": data.payload.authParams.encoreName,
        "EncoreSleepLab": data.payload.authParams.encoreSleepLab,
        "ScreenerEmailFrequency": data.payload.authParams.screenerEmailFrequency,
        "GlobalSummaryAccess": parseInt(data.payload.authParams.globalSummaryAccess),
        'Organizations': data.payload.authParams.organizations,
        'Referrals': data.payload.authParams.referrals,
        'ReferralType': data.payload.authParams.referralType,
        "SleepScreenerAccess": parseInt(data.payload.authParams.sleepScreenerAccess),

        // ImageData != "" && RequestParam.CurrentImageName
    });
    const URL = `${process.env.REACT_APP_API_URL}api/user/updateloggedinuserdetail`;
    const instance = await axios.create();
    const options = {
        headers: {
            'Content-Type': 'application/json', 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${Id}`
        }
    };
    const response = await instance.post(URL, data, options);
    if (response.data.success) {

        data = JSON.parse(data);
        if (data) {
            parsedJsonData.name = data.name;
            parsedJsonData.title = data.title;
            parsedJsonData.phone = data.phone;
            parsedJsonData.extension = data.extension;
            parsedJsonData.password = data.password;
            parsedJsonData.ImageData = data.ImageData;
            parsedJsonData.isPapUser = data.isPapUser;
            parsedJsonData.PapType = data.PapType;
            parsedJsonData.CurrentImageName = data.CurrentImageName;
            parsedJsonData.avatar = data.avatar;
            // parsedJsonData.avatarWithFullPath = data.ImageData;
            let localStorageItems = JSON.parse(localStorage.getItem("persist:userData"));

            localStorageItems.user = JSON.stringify(parsedJsonData)
            // localStorageItems.authToken = authToken,
            localStorage.setItem("persist:userData", JSON.stringify(localStorageItems));
            return response;
        }
    }
    return response;
}

function* fetchSalesOrderFilterListSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchSalesOrderFilterListAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchSalesOrderFilterListSuccess(response.data))
    }
    else {
        yield put(actions.fetchSalesOrderFilterListFailure(response.data))
    }
};

const fetchSalesOrderFilterListAPI = async (authToken, userByToken, payload, Rts, PtKey) => {
    var data = payload.payload;
    let RtsCount = (data.PageNo > 0) ? (data.PageNo * data.PageSize) : 0;
    const user = JSON.parse(userByToken);
    let reqData = {
        statusParam: data.statusParam || '',
        salesRepParam: data.salesRepParam || '',
        doctorParam: data.doctorParam || '',
        doctorNameParam: data.doctorNameParam || '',
        doctorFirstNameParam: data.doctorFirstNameParam || '',
        doctorLastNameParam: data.doctorLastNameParam || '',
        insuranceParam: data.insuranceParam || '',
        maskTypeParam: data.maskTypeParam || '',
        complianceRiskParam: data.complianceRiskParam || '',
        equipmentTypeParam: data.equipmentTypeParam || '',
        daysSinceSetupParam: data.daysSinceSetupParam || '',
        organizationParam: data.organizationParam || '',
        referralParam: data.referralParam || '',
        limitParam: 2000, //data.PageSize || 10
        startDate: data.startDate || '',
        endDate: data.endDate || '',
        patientNameParam: data.patientNameParam || '',
        patientFirstNameParam: data.patientFirstNameParam || '',
        patientNameLastParam: data.patientNameLastParam || '',
        dateOfBirthParam: data.dateOfBirthParam || '',
        rowsToSkip: RtsCount,
        orderByFieldParam: data.orderByFieldParam || '',
        sortOrderParam: data.sortOrderParam || ''
    }

    // const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getsalesorderfilterlist?statusParam=&salesRepParam=&doctorParam=&doctorNameParam=&doctorFirstNameParam=&doctorLastNameParam=&insuranceParam=&maskTypeParam=&complianceRiskParam=&equipmentTypeParam=&daysSinceSetupParam=&organizationParam=${data.organizationParam}&referralParam=${data.referralParam}&limitParam=${data.PageSize}&startDate=&endDate=&patientNameParam=&patientFirstNameParam=&patientNameLastParam=&dateOfBirthParam=&rowsToSkip=${RtsCount}&orderByFieldParam=OrderStatus&sortOrderParam=`;
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getsalesorderfilterlist`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        params: reqData
    };
    const respo = instance.get(URL, options);
    return respo;
};



function* fetchSalesOrderFilterListAdherenceInfoSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchSalesOrderFilterListAdherenceInfoAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchSalesOrderFilterListAdherenceInfoSuccess(response.data))
    }
    else {
        yield put(actions.fetchSalesOrderFilterListAdherenceInfoFailure(response.data))
    }
};

const fetchSalesOrderFilterListAdherenceInfoAPI = async (authToken, userByToken, payload) => {
    if (cancel !== undefined) {
        cancel();
    }
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/GetAveragePatientUsageData?ptKey=${ptKey}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        cancelToken: new CancelToken(function executor(c) {
            cancel = c;
        }) 
    };
    const respo = instance.get(URL, options); 
    return respo;
};

function* fetchLogosSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchLogosAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchLogosSuccess(response.data))
    }
    else {
        yield put(actions.fetchLogosFailure(response.data))
    }
};

const fetchLogosAPI = async (authToken, userByToken, payload) => {
    if (cancel !== undefined) {
        cancel();
    }
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    if(payload.payload.OrderByFieldParam === 'isSleepScreenerEnabled')
    {
        if(payload.payload.SortOrderParam === 'asc') {
            payload.payload.SortOrderParam = 'desc';
        }
        else if(payload.payload.SortOrderParam === 'desc') {
            payload.payload.SortOrderParam = 'asc';
        }
    }
    const URL = `${process.env.REACT_APP_API_URL}api/logo/getlogolist?OrganizationParam=${JSON.parse(localStorage.getItem('persist:userData')).organizationParam.replace(/"/g, '')}&LimitParam=${payload.payload.LimitParam}&OffsetParam=${payload.payload.OffsetParam}&OrderByFieldParam=${payload.payload.OrderByFieldParam}&SortOrderParam=${payload.payload.SortOrderParam}&SearchParam=${payload.payload.SearchParam}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replaceAll('"', '')}`, "UserId": `${user.userId}` },
        cancelToken: new CancelToken(function executor(c) {
            cancel = c;
        })
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* fetchLogoDetailSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchLogoDetailAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchLogoDetailSuccess(response.data))
    }
    else {
        yield put(actions.fetchLogoDetailFailure(response.data))
    }
};

const fetchLogoDetailAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/logo/getlogobyid?Referralkey=${payload.payload.Referralkey}&OrganizationId=${payload.payload.OrganizationId}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` }
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* saveLogoDetailSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(saveLogoDetailAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.saveLogoDetailSuccess(response.data))
    }
    else {
        yield put(actions.saveLogoDetailFailure(response.data))
    }
};

const saveLogoDetailAPI = async (authToken, userByToken, payload) => {
    var data = JSON.stringify({
        "OrganizationId": payload.payload.OrganizationId,
        "Referralkey": payload.payload.Referralkey,
        "CurrentImageName": payload.payload.CurrentImageName,
        "ImageData": payload.payload.ImageData,
        "IsSleepScreenerEnabled": payload.payload.enable_referral_specific_link,
    });

    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/logo/addandupdateuserlogo`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` }
    };
    const respo = instance.post(URL, data, options);
    return respo;
};


function* fetchAdherenceBreakdownDetailSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchAdherenceBreakdownDetailAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchAdherenceBreakdownDetailSuccess(response.data))
    }
    else {
        yield put(actions.fetchAdherenceBreakdownDetailFailure(response.data))
    }
};

const fetchAdherenceBreakdownDetailAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    let referralParamValue = localStorage.getItem('newReferralParamForPieChartSelection');
    if(!localStorage.getItem('newReferralParamForPieChartSelection')) {
        referralParamValue = JSON.parse(localStorage.getItem('persist:userData')).referralParam.replace(/"/g,'');
    }
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getadherencebreakdowndetail?OrganizationParam=${JSON.parse(localStorage.getItem('persist:userData')).organizationParam.replace(/"/g,'')}&ReferralParam=${referralParamValue}&Type=${payload.payload.Type}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` }
    };
    const respo = instance.get(URL, options);
    return respo;
};


function* fetchResmedSummaryDocSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchResmedSummaryDocAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchResmedSummaryDocSuccess(response.data))
    }
    else {
        yield put(actions.fetchResmedSummaryDocFailure(response.data))
    }
};

const fetchResmedSummaryDocAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getresmedsummarydocument`;
    const instance = await axios.create({});
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        params: {
            "Days": 60,
            "AirViewFlag": "CCE34AEE-FDC7-445D-8DB1-5AE75CDD50D1"
        }
    };
    const respo = instance.get(URL, options);
    return respo;
};


function* fetchNonPAPDashboardDetailsSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchNonPAPDashboardDetailsAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchNonPAPDashboardDetailsSuccess(response.data))
    }
    else {
        yield put(actions.fetchNonPAPDashboardDetailsFailure(response.data))
    }
};

const fetchNonPAPDashboardDetailsAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getnonpapdashboarddetails?RoleId=${payload.payload.RoleId}&OrganizationParam=${payload.payload.OrganizationParam}&ReferralParam=${payload.payload.ReferralParam}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` }
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* fetchNonPAPSalesOrderDetailsListByStatusSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchNonPAPSalesOrderDetailsListByStatusAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchNonPAPSalesOrderDetailsListByStatusSuccess(response.data))
    }
    else {
        yield put(actions.fetchNonPAPSalesOrderDetailsListByStatusFailure(response.data))
    }
};

const fetchNonPAPSalesOrderDetailsListByStatusAPI = async (authToken, userByToken, payload) => {
    // const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getnonpapsalesorderdetailslistbystatus?IsStatusNameParam=${payload.payload.IsStatusNameParam}&StatusNameParam=${payload.payload.StatusNameParam}&DateRange=300&ReferralParam=${payload.payload.ReferralParam}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` }
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* fetchNonPAPChartDetailSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchNonPAPChartDetailAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchNonPAPChartDetailSuccess(response.data))
    }
    else {
        yield put(actions.fetchNonPAPChartDetailFailure(response.data))
    }
};

const fetchNonPAPChartDetailAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/GetNonPAPDeliveredAndUnDeliveredChartDetail?&Organization=${payload.payload.OrganizationParam}&ReferralKey=${payload.payload.ReferralParam}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` }
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* fetchNonPAPPatientDetailSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchNonPAPPatientDetailAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchNonPAPPatientDetailSuccess(response.data))
    }
    else {
        yield put(actions.fetchNonPAPPatientDetailFailure(response.data))
    }
};

const fetchNonPAPPatientDetailAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getnonpappatientdetail?ReferralKey=${payload.payload.ReferralKey}&PatientNameParam=${payload.payload.PatientNameParam}`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` }
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* fetchNonPAPSalesListByFilterSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchNonPAPSalesListByFilterAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchNonPAPSalesOrderDetailsListByStatusSuccess(response.data))
    }
    else {
        yield put(actions.fetchNonPAPSalesOrderDetailsListByStatusFailure(response.data))
    }
};

const fetchNonPAPSalesListByFilterAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getnonpapsalesorderdetailslistbyfilters`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        params: payload.payload
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* fetchScreenedPatientListSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchScreenedPatientListAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchScreenedPatientListSuccess(response.data))
    }
    else {
        yield put(actions.fetchScreenedPatientListFailure(response.data))
    }
};

const fetchScreenedPatientListAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/GetScreenedPatientList`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        params: payload.payload
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* checkForMenuItemAccessSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(checkForMenuItemAccessAPI, authToken, userByToken);
    if (response.data.success == true) {
        yield put(actions.checkForMenuItemAccessSuccess(response.data))
    }
    else {
        yield put(actions.checkForMenuItemAccessFailure(response.data))
    }
};

const checkForMenuItemAccessAPI = async (authToken, userByToken) => {
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/CheckForMenuItemAccess`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        params: {}
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* fetchSalesRepresentativesSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchSalesRepresentativesAPI, authToken, userByToken);
    if (response.data.success == true) {
        yield put(actions.fetchSalesRepresentativesSuccess(response.data))
    }
    else {
        yield put(actions.fetchSalesRepresentativesFailure(response.data))
    }
};

const fetchSalesRepresentativesAPI = async (authToken, userByToken) => {
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getsalesrepresentatives`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        params: {}
    };
    const respo = instance.get(URL, options);
    return respo;
};


function* fetchPatientNotesListSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchPatientNotesListAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchPatientNotesListSuccess(response.data))
    }
    else {
        yield put(actions.fetchPatientNotesListFailure(response.data))
    }
};

const fetchPatientNotesListAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getpatientnotelist`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        params: payload.payload
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* fetchScreenerDataListSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchScreenerDataListAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchScreenerDataListSuccess(response.data))
    }
    else {
        yield put(actions.fetchScreenerDataListFailure(response.data))
    }
};

const fetchScreenerDataListAPI = async (authToken, userByToken, payload) => {
    const ptKey = payload.payload.ptKey;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getscreeneddata`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        params: payload.payload
    };
    const respo = instance.get(URL, options);
    return respo;
};

function* setAddPatientNotesSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(setAddPatientNotesAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.setAddPatientNotesSuccess(response.data))
    }
    else {
        yield put(actions.setAddPatientNotesFailure(response.data))
    }
};

const setAddPatientNotesAPI = async (authToken, userByToken, payload) => {

    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/AddAndUpdatePatientNote`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` }
    };
    const respo = instance.post(URL, payload.payload, options);
    return respo;
};

function* setPandingSleepStudySaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(setPandingSleepStudyAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.setPandingSleepStudySuccess(response.data))
    }
    else {
        yield put(actions.setPandingSleepStudyFailure(response.data))
    }
};

const setPandingSleepStudyAPI = async (authToken, userByToken, payload) => {

    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/updatefollowupstatus`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` }
    };
    const respo = instance.post(URL, payload.payload, options);
    return respo;
};

function* fetchMaskTypeListSaga(payload) {
    const authToken = yield getAuthToken();
    const userByToken = yield getUserByToken();
    const response = yield call(fetchMaskTypeListAPI, authToken, userByToken, payload.payload);
    if (response.data.success == true) {
        yield put(actions.fetchMaskTypeListSuccess(response.data))
    }
    else {
        yield put(actions.fetchMaskTypeListFailure(response.data))
    }
};

const fetchMaskTypeListAPI = async (authToken, userByToken, payload) => {

    const organizationParam = payload.payload.organizationParam;
    const referralParam = payload.payload.referralParam;
    const user = JSON.parse(userByToken);
    const URL = `${process.env.REACT_APP_API_URL}api/dashboard/getmasktyperesult`;
    const instance = await axios.create({
    });
    const options = {
        headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replace(/"/g,'')}`, "UserId": `${user.userId}` },
        params: payload.payload
    };
    const respo = instance.get(URL, options);
    return respo;
};